import { render, staticRenderFns } from "./ExcluirMovimentosEmLote.vue?vue&type=template&id=e70fe408"
import script from "./ExcluirMovimentosEmLote.vue?vue&type=script&lang=js"
export * from "./ExcluirMovimentosEmLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports